export default __webpack_public_path__ + "8308fecc6a266f35dac1abd7d3598dfc.jpg";